import { render, staticRenderFns } from "./InfoUser.vue?vue&type=template&id=50997f03&scoped=true&"
import script from "./InfoUser.vue?vue&type=script&lang=js&"
export * from "./InfoUser.vue?vue&type=script&lang=js&"
import style0 from "./InfoUser.vue?vue&type=style&index=0&id=50997f03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50997f03",
  null
  
)

export default component.exports